export default "__VITE_ASSET__DFYrlxIx__"